<template>
  <div>
    <div
      :class="[
        'md-collapse',
        activeCollapse(index + 1),
        { [getColorCollapse(colorCollapse)]: true }
      ]"
      v-for="(item, index) in collapse"
      :key="index"
    >
      <div class="md-collapse-label" @click="toggle(index + 1)">
        <h5 class="md-collapse-title">
          <md-field style="margin:0">
            <div
              class="md-input"
              style="padding-left:5px; font-weight: 400; color: #000;"
              :style="noCollapse ? 'background-color:#ccc' : ''"
              v-if="item.lock || disabled"
            >
              {{ item.title }}
            </div>
            <md-input
              v-else
              style="padding-left:5px"
              v-model="item.title"
              :style="noCollapse ? 'background-color:#ccc' : ''"
              >{{ item.title }}</md-input
            ></md-field
          >
          <div v-if="!disabled">
            <div @click="addItem(index)">
              <md-icon
                v-show="noCollapse && getActiveCollapse(index + 1)"
                style="right: 110px"
                >add</md-icon
              >
            </div>
            <div @click="moveUp(index)">
              <md-icon v-show="getActiveCollapse(index + 1)" style="right: 80px"
                >arrow_upward</md-icon
              >
            </div>
            <div @click="moveDown(index)">
              <md-icon v-show="getActiveCollapse(index + 1)" style="right: 50px"
                >arrow_downward</md-icon
              >
            </div>
            <div v-if="item.lock">
              <md-icon v-show="getActiveCollapse(index + 1)" style="right: 20px"
                >lock</md-icon
              >
            </div>
            <div v-else @click="deleteItem(index)">
              <md-icon v-show="getActiveCollapse(index + 1)" style="right: 20px"
                >delete_forever</md-icon
              >
            </div>
          </div>
        </h5>
      </div>

      <collapse-transition>
        <div
          class="md-collapse-content"
          v-show="noCollapse || getActiveCollapse(index + 1)"
        >
          <slot :name="getCollapseContent(index + 1)"></slot>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "collapse",
  components: {
    CollapseTransition
  },
  props: {
    collapse: Array,
    icon: String,
    colorCollapse: String,
    noCollapse: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: 0
    };
  },
  methods: {
    getActiveCollapse(index) {
      return this.isActive == index;
    },
    activeCollapse(index) {
      return {
        "is-active": this.noCollapse || this.isActive == index
      };
    },
    toggle(index) {
      if (index == this.isActive) {
        this.isActive = 0;
      } else {
        this.isActive = index;
      }
    },
    getCollapseContent: function(index) {
      return "md-collapse-pane-" + index + "";
    },
    getColorCollapse: function(colorCollapse) {
      return "md-" + colorCollapse + "";
    },
    addItem(index) {
      this.collapse[index].items.push({
        title: this.$t("new item"),
        verbal: false,
        description: "Add Item"
      });
    },
    deleteItem(index) {
      this.collapse.splice(index, 1);
    },
    moveUp(index) {
      if (index > 0) {
        var item = this.collapse[index];
        this.collapse.splice(index, 1);
        this.collapse.splice(index - 1, 0, item);
      }
    },
    moveDown(index) {
      if (index < this.collapse.length - 1) {
        var item = this.collapse[index];
        this.collapse.splice(index, 1);
        this.collapse.splice(index + 1, 0, item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  display: flex;
}
</style>
